import { useMutation } from '@ztechapps/common.hook'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery('Customer', `_id phone`)

export const useUpdateRegistration = () => {
  return useMutation({
    query: queries.updateConfig.query,
  })
}
